export const scrollTop = () => window.scrollTo(0, 0);

export const scrollBottom = () => window.scrollTo(0, document.body.scrollHeight);

export const getFullUrl = (url) => window.location.origin + url;
